import type { TFunction } from "i18next";

import { CHAT_CONTEXT_IDS, type ChatContextId } from "../../../store/aiChatStore";

export const WELCOME_CONTEXTS = CHAT_CONTEXT_IDS;

export type WelcomeContext = ChatContextId;

export interface WelcomeFleet {
  total: number;
  moving: number;
  stopped: number;
}

const greetingKeyOf = (hour: number) => {
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 19) return "afternoon";
  return "evening";
};

export function buildGreeting(t: TFunction, name?: string): string {
  return t(`monitoreoIa.chat.welcome.greeting.${greetingKeyOf(new Date().getHours())}`, {
    name: name ?? t("monitoreoIa.summary.fallbackName"),
  });
}

export function buildPlainWelcome(
  context: WelcomeContext,
  t: TFunction,
  name?: string,
  fleet?: WelcomeFleet | null,
): string {
  const intro = t(`monitoreoIa.chat.welcome.plain.${context}`);
  const summary = fleet
    ? t("monitoreoIa.chat.welcome.fleetSummary", {
        count: fleet.total,
        moving: fleet.moving,
        stopped: fleet.stopped,
      })
    : null;

  return [buildGreeting(t, name), summary, intro].filter(Boolean).join("\n\n");
}
